/*
 * @Description: 公共接口
 * @Author: LiuYongChun
 * @Date: 2020-10-27 17:29:28
 * @LastEditors: LiuYongChun
 * @LastEditTime: 2020-12-08 11:36:15
 */
import { IUSER, ILog } from '@/types/app.d';
import fetch from './index';

// 用户登录
const login = (data: IUSER) => {
  const params = new URLSearchParams();
  params.append('loginName', data.user);
  params.append('password', data.pass);

  return fetch.axios_admin.post('/login', params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
};

// 日志上传
/* eslint-disable prefer-template */
const logUpdate = (data: ILog) => fetch.axios_mock.get('/log.gif', data);

// 获取知识点list
const getKnowledge = () => fetch.axios_admin.get('/dict/root/knowledge');

// 获取课程类型list
const getCourseType = () => fetch.axios_admin.get('/course/type/cascader');

// 根据基础数据类型获取相应的基础数据
const getBaseDataByType = (data: object) => fetch.axios_admin.get(`/common/basic_config_data?dictTypes=${data}`);

export default {
  login,
  logUpdate,
  getKnowledge,
  getCourseType,
  getBaseDataByType,
};
